import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import usePageProduct from '../../hooks/usePageProduct'
import Affirm from './index'
import useBrand from '../../hooks/useBrand'

export const AffirmPriceComponent: React.FC = () => {
  const pageSku = usePageProduct()
  const brand = useBrand()
  const { classes, cx } = useStyles()

  return (
    <>
      {pageSku?.amount && pageSku.plan_code && brand.name === 'TopResume' && (
        <Box className={cx(classes.priceContainer)}>
          <Affirm price={pageSku.amount} planCode={pageSku.plan_code} />
        </Box>
      )}
    </>
  )
}

const useStyles = makeStyles()({
  priceContainer: {
    minHeight: '1.375rem',
  },
})

export default AffirmPriceComponent
